import {Component, inject} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {ModalService, PlanService} from '@core/services';
import {Confirm} from '@core/modals';
import {DatePicker} from '@core/components';
import {Router} from '@angular/router';

@Component({
  selector: 'core-plan-form',
  imports: [
    DatePicker,
    ReactiveFormsModule
  ],
  standalone: true,
  templateUrl: './plan-form.html',
  styleUrl: './plan-form.scss',
  host: {
    style: 'width: 100%;display: flex;flex-direction: column;gap: 1.25rem;padding: 0 1rem 0.5rem;background:var(--background-color)'
  }
})
export class PlanForm {

  private readonly modal = inject(ModalService);
  private readonly router = inject(Router);
  private readonly planService = inject(PlanService);
  private readonly formBuilder = inject(FormBuilder);
  form: FormGroup;
  isSubmitting = false;
  errorMessage = '';

  constructor() {
    this.form = this.formBuilder.group({
      name: ['', [Validators.required]],
      dateRange: [null, [Validators.required]],
      description: [''],
      goals: ['']
    });
  }

  confirm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.close();
    this.modal.open<Confirm, boolean>(Confirm, {
      inputs: {
        title: 'Cerrar plan actual y abrir nuevo',
        description: 'Vas a cerrar el plan actual (plan 2024) y a iniciar el siguiente. Una vez se inicie este proceso, no podrá revertirse. Por favor, introduce los datos del siguiente plan.',
        confirmText: 'Cerrar plan actual',
      },
      outputs: {
        confirm: () => {
          this.submitForm();
        }
      },
      options: { size: 'sm', closeOnBackdrop: false },
    });
  }

  async submitForm() {
    if (this.isSubmitting) return;
    this.isSubmitting = true;
    this.errorMessage = '';

    const value = this.form.value;
    const payload = {
      name: value.name,
      description: value.description || undefined,
      goals: value.goals || undefined,
      startDate: value.dateRange?.start || null,
      endDate: value.dateRange?.end || null
    };

    const response = await this.planService.createPlan(payload);
    this.isSubmitting = false;

    if (!response.success || !response.result) {
      this.errorMessage = response.message || 'No se pudo crear el plan.';
      return;
    }

    await this.router.navigate(['dashboard/plan/wizard'], {
      queryParams: {planId: response.result.id},
      queryParamsHandling: 'merge'
    });
  }

  close() {
    this.modal.closeTop();
  }
}
